import type { ComponentType } from 'react';
import { CORE_PROJECT } from '@jira/platform__project-types/src/project-types.tsx';
import { projectLayout } from '@atlassian/jira-project-layout/src/index.tsx';
import {
	composeLayouts,
	withProjectContext,
	type Layout,
} from '@atlassian/jira-route-layout/src/GlobalComponent.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const Onboarding = lazyAfterPaint(
	() => import(/* webpackChunkName: "async-business-project-onboarding" */ './ui/onboarding'),
	{ ssr: false },
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const withAnyBusinessProjectContext = (Component: ComponentType<Record<any, any>>) =>
	withProjectContext(Component, {
		project: {
			style: 'any',
			type: CORE_PROJECT,
		},
	});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const RightSidebars = lazyAfterPaint(
	() =>
		import(/* webpackChunkName: "async-business-project-right-sidebars" */ './ui/right-sidebars'),
	{ ssr: false },
);

const BusinessOnboarding = withAnyBusinessProjectContext(Onboarding);

const nonSettingsRightSidebars = [withAnyBusinessProjectContext(RightSidebars)];

const sharedBusinessProjectLayout: Layout = composeLayouts(projectLayout);

export const businessProjectLayout: Layout = composeLayouts(sharedBusinessProjectLayout, {
	rightSidebars: nonSettingsRightSidebars,
	globalComponents: [BusinessOnboarding],
});
